const CLOUD_BUY_NOW_SELECTOR = '[data-cloud-buy-now]';

if (!window.cloudBuyNowHandlerInstalled) {
  window.cloudBuyNowHandlerInstalled = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(CLOUD_BUY_NOW_SELECTOR);
    if (!button || button.disabled) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    const originalText = button.textContent;
    const root = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    button.textContent = 'Opening checkout…';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || 'Unable to start checkout.');
      }

      window.location.assign(`${root}checkout`);
    } catch (error) {
      button.textContent = error.message || 'Unable to start checkout.';
      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2400);
    }
  });
}
